<template>
  <modal>
    <div class="modal-header">
      <h4>{{getModalHeader()}}</h4>
      <button
        @click="onCloseModal"
        class="btn btn-link btm-sm btn-close-container p-0 mr-3"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div
      v-if="!errorCode"
      class="modal-body"
    >
      <form v-on:submit.prevent="onSubmit">
        <FormGroup :errorMessage="error.name">
          <h5 class="name">ชื่อหมวดหมู่</h5>
          <input
            type="text"
            placeholder="ชื่อหมวดหมู่"
            class="form-control"
            :class="{'is-invalid': error.name}"
            v-model="taxonomy.name"
          />
          <div
            class="invalid-feedback"
            v-if="error.name"
          >
            {{error.name}}
          </div>
        </FormGroup>
        <FormGroup :errorMessage="error.key">
          <h5 class="name">ชื่อคีย์</h5>
          <input
            type="text"
            placeholder="ชื่อคีย์"
            class="form-control"
            :class="{'is-invalid': error.key}"
            v-model="taxonomy.key"
          />
          <div
            class="invalid-feedback"
            v-if="error.key"
          >
            {{error.key}}
          </div>
        </FormGroup>
        <div class="form-action">
          <button
            :disabled="!canSave()"
            type="submit"
            class="btn btn-primary btn-create"
          >{{getButtonLabel()}}</button>
        </div>
      </form>
    </div>
    <EmptyMessage v-if="errorCode">
      <h3>เกิดข้อผิดพลาดขณะบันทึก</h3>
      <router-link
        :to="`/taxonomy`"
        class="btn btn-light btn-lg mt-4"
      >
        กลับสู่หน้าแท็ก
      </router-link>
      <span
        slot="code"
        class="code"
      >
        Code : {{errorCode.statusCode || 'not found' }}
      </span>
    </EmptyMessage>
  </modal>
</template>

<script>
import _ from 'lodash';
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import {
  createTaxonomy,
  loadTaxonomyDetail,
  editTaxonomy,
} from './api';

export default {
  components: {
    Modal,
    FormGroup,
    EmptyMessage,
  },
  data() {
    return {
      errorCode: null,
      taxonomy: {
        name: null,
        key: null,
      },
      error: {
        name: null,
        key: null,
      },
    };
  },
  computed: {
    isEditMode() {
      const isEdit = this.$route.path.includes('edit');
      return isEdit;
    },
    tagKey() {
      return this.$route.params.tagKey;
    },
  },
  async created() {
    if (this.isEditMode) {
      try {
        const response = await loadTaxonomyDetail(this.tagKey);
        const { data } = response;
        this.taxonomy.name = data.name;
        this.taxonomy.key = data.key;
      } catch (error) {
        this.errorCode = error.response.status;
      }
    }
  },
  methods: {
    getModalHeader() {
      if (this.isEditMode) {
        return 'แก้ไขหมวดหมู่';
      }
      return 'สร้างหมวดหมู่ใหม่';
    },
    getButtonLabel() {
      if (this.isEditMode) {
        return 'แก้ไขหมวดหมู่';
      }
      return 'สร้างหมวดหมู่';
    },
    async onSubmit() {
      this.errorCode = null;
      try {
        if (this.isEditMode) {
          await editTaxonomy(this.tagKey, this.taxonomy);
        } else {
          await createTaxonomy(this.taxonomy);
        }
        this.onCloseModal();
      } catch (error) {
        if (error.response.status === 422) {
          this.error.name = 'กรุณาตรวจสอบข้อมูลที่กรอกอีกครั้ง';
          this.error.key = 'กรุณาตรวจสอบข้อมูลที่กรอกอีกครั้ง';
        } else {
          this.error.name = 'เกิดข้อผิดพลาดขณะบันทึก';
          this.error.key = 'เกิดข้อผิดพลาดขณะบันทึก';
        }
      }
    },
    onCloseModal() {
      this.$router.back();
    },
    canSave() {
      return (
        !_.isEmpty(this.taxonomy.name)
        && !_.isEmpty(this.taxonomy.key)
        && this.checkKey()
        && this.checkName()
      );
    },
    checkName() {
      if (_.isEmpty(this.taxonomy.name)) {
        // this.error.name = 'กรุณาใส่ชื่อ';
        return false;
      }
      // this.error.name = null;
      return true;
    },
    checkKey() {
      if (!this.isEnglishOnly(this.taxonomy.key)) {
        // this.error.key = 'อนุญาตให้ใช้เฉพาะภาษาอังกฤษเท่านั้น';
        return false;
      }
      return true;
    },
    isEnglishOnly(string) {
      return /^[a-zA-Z0-9-]+$/.test(string);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-action {
  display: flex;
  .btn-create {
    margin-left: auto;
  }
}
</style>
